import { render, staticRenderFns } from "./validation-messages.vue?vue&type=template&id=a63a9a54&scoped=true&lang=pug&"
import script from "./validation-messages.vue?vue&type=script&lang=ts&"
export * from "./validation-messages.vue?vue&type=script&lang=ts&"
import style0 from "./validation-messages.vue?vue&type=style&index=0&id=a63a9a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a9a54",
  null
  
)

export default component.exports